export const JourneyTypes = {
    INSTANT_WIN: 'instant-win',
    VOUCHER: 'voucher',
    GAME: 'game',
};
